import React, {Fragment, useEffect, useState} from "react";
import {useAdvancedSearchCMMutation, useGetSynchroCMMutation} from "../../core/api/cloclmaker-state-api";
import AdvancedSearch from "./index";

export default function AdvancedSearchCM() {

    return <AdvancedSearch useSearchHook={useAdvancedSearchCMMutation} />
}